import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import LoginViaAppleMutation from './LoginViaAppleMutation';

const LoginViaAppleConnectorApollo = ({ children }) => {
  const [mutate, { loading }] = useMutation(LoginViaAppleMutation);

  const createLogin = async (token) => {
    const response = await mutate({
      variables: {
        token,
      },
    });

    return response;
  };

  return children({
    loginViaApple: createLogin,
    loading,
  });
};

LoginViaAppleConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default LoginViaAppleConnectorApollo;
